module.exports = __webpack_public_path__ + "img/eduac-mac-courses.a76cae63.png";